// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"1bf5dad5","332":"902aee5c","356":"fcbeddf0","466":"421f8555","607":"d7305f6a","984":"aedb51e3","998":"05b52ef7"}[chunkId] + ".chunk.js";
};